// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__x_dOq","disabled":"FileBtn_disabled__3gETm","warn":"FileBtn_warn__3cbQz","fade":"FileBtn_fade__233Rm"};